import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import eraseSign from "@/assets/images/svg/erase-sign.svg";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: ModalComponents.PaymentCalculator,
  props: {
    visible: {
      required: false,
      type: Object
    },
    placeHolderValue: {
      required: false,
      type: Object
    }
  },
  emits: ["confirmNumber"
  /* this event is declared in the parent component Modal*/
  , "cancelCalculator"],
  setup: function setup(props) {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var iconStyle = "width: 40px; height: 30px;";
    var iconContent = eraseSign;
    var iconAlt = "erase";
    var dialogVisible = ref(props.visible ? props.visible : dialogVisibleForStatus(ModalStatus.PaymentCalculator));
    var inputContent = props.placeHolderValue ? ref(props.placeHolderValue.toString()) : ref("0.00");
    var initialArray = ["0", "0", "0"];
    var count = 0;
    var currentCurrency = computed(function () {
      var _BookingModule$select, _BookingModule$select2;

      return ((_BookingModule$select = BookingModule.selectedCashCurrency) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.label) || ((_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.currency);
    });
    var selectedCashCurrency = computed(function () {
      return BookingModule.selectedCashCurrency;
    });

    function clearInput() {
      inputContent.value = "0.00";
      count = 0;
      initialArray = ["0", "0", "0"];
    }

    function updateInputDoubleZero() {
      if (count >= 1) {
        updateInput(String(0));
        updateInput(String(0));
      }

      if (count === 0) {
        return;
      }
    }

    function updateZero() {
      if (count >= 1) {
        updateInput(String(0));
      }

      if (count === 0) {
        return;
      }
    }

    function eraseFromInput() {
      if (count === 1 || count === 0) {
        inputContent.value = "0.00";
        count = 0;
        initialArray = ["0", "0", "0"];
      } else if (count === 2) {
        count = count - 1;
        initialArray.pop();
        initialArray.unshift("0");
        inputContent.value = "".concat(initialArray[0], ".").concat(initialArray[1]).concat(initialArray[2]);
      } else if (count === 3) {
        count = count - 1;
        initialArray.pop();
        initialArray.unshift("0");
        inputContent.value = "".concat(initialArray[0], ".").concat(initialArray[1]).concat(initialArray[2]);
      } else if (count >= 4) {
        count = count - 1;
        initialArray.pop();
        var decimalDivider = initialArray.length - 2;
        inputContent.value = initialArray.slice(0, decimalDivider).join("") + "." + initialArray.slice(decimalDivider, decimalDivider + 2).join("");
      }
    }

    function updateInput(char) {
      if (count === 0) {
        inputContent.value = "".concat(initialArray[0], ".").concat(initialArray[1]).concat(char);
        initialArray.push(char);
        initialArray.shift();
        count = 1;
      } else if (count === 1) {
        inputContent.value = "".concat(initialArray[0], ".").concat(initialArray[2]).concat(char);
        initialArray.push(char);
        initialArray.shift();
        count = 2;
      } else if (count === 2) {
        inputContent.value = "".concat(initialArray[1], ".").concat(initialArray[2]).concat(char);
        initialArray.push(char);
        initialArray.shift();
        count = 3;
      } else {
        initialArray.push(char);
        count = count + 1;
        var decimalDivider = initialArray.length - 2;
        inputContent.value = initialArray.slice(0, decimalDivider).join("") + "." + initialArray.slice(decimalDivider, decimalDivider + 2).join("");
      }
    }

    function cancel() {
      // Clear the calculator and close it
      clearInput();

      if (ModalModule.status === ModalStatus.PaymentCalculator) {
        ModalModule.setStatus(ModalStatus.Hidden);
      } else {
        // this is the case where the calculator is not used inside Modal component, lets emit to cancellation event on parent component
        this.$emit("cancelCalculator");
      }
    }

    return {
      dialogVisible: dialogVisible,
      inputContent: inputContent,
      currentCurrency: currentCurrency,
      clearInput: clearInput,
      eraseFromInput: eraseFromInput,
      updateInput: updateInput,
      cancel: cancel,
      initialArray: initialArray,
      count: count,
      t: t,
      iconStyle: iconStyle,
      iconContent: iconContent,
      iconAlt: iconAlt,
      props: props,
      updateInputDoubleZero: updateInputDoubleZero,
      updateZero: updateZero,
      selectedCashCurrency: selectedCashCurrency
    };
  }
});